/**
 * Passport / ID card upload that fills the profile — the request contracts.
 */
import { IDENTITY_DOCUMENT_APPLY_FIELDS } from '@tonnie/types';
import { z } from 'zod';

/** One file for a passport; front then back for an ID card. */
export const identityDocumentReadSchema = z.object({
  documentType: z.enum(['passport', 'id_card']),
  vaultFileIds: z.array(z.uuid()).min(1).max(2),
});
export type IdentityDocumentReadInput = z.infer<typeof identityDocumentReadSchema>;

/**
 * The lines of the review the citizen ticked — an empty list applies nothing.
 *
 * The keys come from IDENTITY_DOCUMENT_APPLY_FIELDS, the list the review and
 * the confirm are built from. A copy of it here missed `account_name` when that
 * line was added (5765654f1), so ticking "use it as your account name" made
 * every save a 400.
 */
export const identityDocumentConfirmSchema = z.object({
  apply: z.array(z.enum(IDENTITY_DOCUMENT_APPLY_FIELDS)).max(IDENTITY_DOCUMENT_APPLY_FIELDS.length),
});
export type IdentityDocumentConfirmInput = z.infer<typeof identityDocumentConfirmSchema>;
